<script>
export default {
    name: "CancelledInvoiceForm",
}
</script>
<template>
    <div class="w-full overflow-auto mt-px">
        <table class="table table-hover">
            <thead class="bg-blue-500 text-xs text-white">
                <tr class="w-full flex">
                    <th class="p-tiny w-1/6">Supplier</th>
                    <th class="p-tiny w-1/6">Invoice No</th>
                    <th class="p-tiny w-1/6">Txn Date</th>
                    <th class="p-tiny w-1/6">Requested By</th>
                    <th class="p-tiny w-1/6">Requested Memo</th>
                    <th class="p-tiny w-1/6">Currency</th>
                    <th class="p-tiny w-1/6">Amount</th>
                </tr>
            </thead>
        </table>
    </div>
</template>
